import React, { useState } from "react";
import { Container, Modal } from "react-bootstrap";
import fraudAlert from "../../Images/fraud-alert.jpg";
import "./FraudAlert.css";

function FraudAlert() {
    const [fraudPopup, setFraudPopup] = useState(true);
    const fraudPopupClose = () => {setFraudPopup(false);};

    return (
        <>
            <Container>
                <Modal show={fraudPopup} onHide={fraudPopupClose} backdrop={true} keyboard={true} className="fraudPopup-popup">
                    <Modal.Body>
                        <div className="fraudPopup-popupbody">
                            <img src={fraudAlert} alt="Fraud Alert" />
                        </div>
                    </Modal.Body>
                </Modal>
            </Container>
        </>
    );
}
export default FraudAlert;
